export enum ProductCommunityStatus {
  /** The product is explicitly part of the customer's community. */
  INCLUDED_IN_COMMUNITY = 'INCLUDED_IN_COMMUNITY',
  /** The product is not in the customer's unlimited-assortment community, but is still orderable. */
  EXCLUDED_BUT_AVAILABLE = 'EXCLUDED_BUT_AVAILABLE',
  /** The product is unavailable because the customer is in a limited-assortment community. */
  UNAVAILABLE_IN_LIMITED_COMMUNITY = 'UNAVAILABLE_IN_LIMITED_COMMUNITY'
}

export enum CommunityType {
  HomeOfficeStore = 'HomeOfficeStore',
  ChooseYourOwnDeviceStore = 'ChooseYourOwnDeviceStore',
  ChristmasStore = 'ChristmasStore',
  BackToSchoolStore = 'BackToSchoolStore',
  GiftStore = 'GiftStore',
  VitalityStore = 'VitalityStore',
  DigisprongStore = 'DigisprongStore',
  PurchasingPortal = 'PurchasingPortal',
  BlueBuiltStore = 'BlueBuiltStore',
  BringYourOwnDeviceStore = 'BringYourOwnDeviceStore',
  Cafetariaplan = 'Cafetariaplan',
  CafetariaplanAnonymous = 'CafetariaplanAnonymous'
}

export type ClosedCommunity = {
  id: string;
  typeDisplayName: string;
  type: CommunityType;
  name: string;
  limitedAssortment: boolean;
  landingPageSitemapNodeId?: string;
};

export type ClosedCommunityType = {
  id: string;
  name: string;
};
